import type { RelatedPlace } from "~/lib/api";
import { RelatedPlacesSection } from "~/components/landing/RelatedPlacesSection";
import { BikeParkNearbyPlaces } from "~/components/landing/BikeParkNearbyPlaces";

interface RelatedPlacesProps {
  type: string;
  relatedPlaces?: RelatedPlace[];
  onSelect?: (place: RelatedPlace) => void;
  className?: string;
}

export function RelatedPlaces({ type, relatedPlaces, onSelect, className }: RelatedPlacesProps) {
  if (!relatedPlaces?.length || !onSelect) return null;

  if (type === "backcountry") {
    return (
      <div className={className}>
        <RelatedPlacesSection relatedPlaces={relatedPlaces} onSelect={onSelect} />
      </div>
    );
  }
  if (type === "bike-park") {
    return (
      <div className={className}>
        <BikeParkNearbyPlaces relatedPlaces={relatedPlaces} onSelect={onSelect} />
      </div>
    );
  }
  return null;
}
